module.exports = "/_next/static/images/las-vegas-nv-efef0b5fccb1a212bef89ec5a24b6d0c.jpg";